export type PAWSectionType = {
  content: any
  data: any
}

export enum ChartType {
  Pie = 'pie',
  Bar = 'bar',
}
